import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { DialogComponent } from './dialog.component';
// import {IgxDialogModule} from "igniteui-angular";
import {DialogDirective} from "./dialog.directive";
// import {DialogContainerComponent} from "./dialog-container.component";
import { DialogCambiaPasswordComponent } from './dialog-cambia-password/dialog-cambia-password.component';
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {DialogConfirmComponent} from "./dialog-confirm/dialog-confirm.component";
import { DialogConfirmAltComponent } from './dialog-confirm-alt/dialog-confirm-alt.component';
import {DialogErrorComponent} from "./dialog-error/dialog-error.component";


@NgModule({
   declarations: [
      // DialogContainerComponent,
      // DialogComponent,
      DialogDirective,
      DialogCambiaPasswordComponent,
      DialogConfirmComponent,
      DialogConfirmAltComponent,
      DialogErrorComponent
   ],
   exports: [
      // DialogContainerComponent
   ],
    imports: [
        CommonModule,
        // IgxDialogModule,
        MatButtonModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatAutocompleteModule
    ]
})
export class DialogModule { }
